import { GlobalStatus, SaleStatusEnum, SoLifeCycleStatusEnum, SoProcessTypesEnum, SoStatusEnum, SoTypesEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { BomDetails } from "./bom-calculation.entity";
import {  SoCustomerInvoice } from "./customer-invoice.entity";
import { DocumentsApproval } from "./entities/documents-approval.entity";
import { SoInvoiceDetails } from "./sale-invoice-details.entity";
import { SaleOrderItems } from "./sale-order-items.entity";
import { SaleInspectionDetails } from "./so-inspections.entity";
import { SaleOrderTrack } from "./so-track.entity";
import { SalePoDetails } from "./so_po_details.entity";

@Entity('sale_order')
export class SaleOrder {

  @PrimaryGeneratedColumn("increment", { name: 'sale_order_id' })
  saleOrderId: number;

  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "sale_order_no"
  })
  saleOrderNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 250,
    name: "filePath"
  })
  filePath: string;

  @Column("int", {
    nullable: true,
    name: "inspection_id"
  })
  inspectionId: number;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoStatusEnum,
    default: SoStatusEnum.OPEN,
    name: "status"
  })
  status: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_invoiced"
  })
  isInvoiced: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoProcessTypesEnum,
    default: SoProcessTypesEnum.MTO,
    name: "so_process_type"
  })
  soProcessType: SoProcessTypesEnum;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoTypesEnum,
    default: SoTypesEnum.DISPATCH,
    name: "so_type"
  })
  soType: SoTypesEnum;

  @Column("boolean", {
    nullable: false,
    default: false,
    name: "cancel_log_flag"
  })
  cancelLogFlag: boolean;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  @Column({
    type: 'enum',
    nullable: false,
    enum: SoLifeCycleStatusEnum,
    default: SoLifeCycleStatusEnum.OPEN,
    name: "life_cycle_status"
  })
  lifeCyclestatus: SoLifeCycleStatusEnum;

  @Column('int',{
    name:'enquiry_id',
    nullable:true
  })
  enquiryId: number

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  // @Column("varchar", {
  //   nullable: false,
  //   length: 50,
  //   name: "invoice_no"
  // })
  // invoiceNumber: string;
  
  @Column('int',{
    name:'ref_no'
})
refNumber : number
@Column('varchar',{
  name:'financial_year',
  nullable:true
})
financialYear : string

  
  @Column('varchar',{
    name:'trade_type',
    length : 20
  })
  tradeType : string
  
  @OneToMany(type => SaleOrderItems, salerderItems => salerderItems.saleOrderInfo, { cascade: true })
  saleOrderItemsInfo: SaleOrderItems[];

  @OneToOne(type => SoInvoiceDetails, SoInvoiceDetails => SoInvoiceDetails.saleOrderInfo, { cascade: true })
  SoInvDetailsInfo: SoInvoiceDetails;

  @OneToOne(type => SaleOrderTrack, soTrack => soTrack.saleOrderInfo, { cascade: true })
  soTrackData: SaleOrderTrack;
  

  @OneToOne(type => SalePoDetails, SalePoDetails => SalePoDetails.saleOrderInfo, { cascade: true })
  SoPoDetailsInfo: SalePoDetails;

  @OneToMany(type => SaleInspectionDetails, SaleInspections => SaleInspections.saleOrderInfo, { cascade: true })
  SoInspectionDetailsInfo: SaleInspectionDetails[];

  @OneToMany(type => BomDetails, bomItems => bomItems.saleOrderInfo, { cascade: true })
  BomDetailsInfo: BomDetails[];

  // @OneToOne(type => SoCustomerInvoice, SoCustomerInvoice => SoCustomerInvoice.saleOrderInfo, { cascade: true })
  // CustomerInvDetailsInfo: SoCustomerInvoice;

  @OneToMany(() => SoCustomerInvoice, invoice => invoice.saleOrderInfo)
CustomerInvDetailsInfo: SoCustomerInvoice[];


  @OneToOne(type => DocumentsApproval, docApr => docApr.saleOrderInfo, { cascade: true })
  docUpInfo: DocumentsApproval;
}
